<template>
  <div class="top-32 mt-16 w-full overflow-auto text-center lg:sticky lg:w-100 lg:pr-12">
    <div class="inline-flex whitespace-nowrap text-left text-xl font-medium text-gray-dark lg:block lg:whitespace-normal">
      <div class="mr-8 lg:mb-10">
        <NuxtLink to="/about" class="font-bw-gradual inline-block font-bold text-black" :class="{ 'nuxt-link-exact-active': $route.name === 'about' }">
          About
        </NuxtLink>

        <div v-if="$route.name === 'about'" class="hidden lg:block">
          <NuxtLink v-scroll-to="'#our-story'" to="/about#our-story" class="mt-4 block hover:text-blue">
            Our Story
          </NuxtLink>
          <NuxtLink v-scroll-to="'#tripexpert-score'" to="/about#tripexpert-score" class="mt-4 block hover:text-blue">
            The Tripexpert Score
          </NuxtLink>
          <NuxtLink v-scroll-to="'#best-price-guarantee'" to="/about#best-price-guarantee" class="mt-4 block hover:text-blue">
            Best price guarantee
          </NuxtLink>
          <NuxtLink v-scroll-to="'#media-coverage'" to="/about#media-coverage" class="mt-4 block hover:text-blue">
            Media coverage
          </NuxtLink>
        </div>
      </div>

      <div class="mr-8 lg:mb-10">
        <NuxtLink to="/experts-choice-awards" class="font-bw-gradual inline-block font-bold text-black" :class="{ 'nuxt-link-exact-active': $route.name === 'awards' }">
          Experts' Choice
        </NuxtLink>

        <div v-if="$route.name === 'experts-choice-awards'" class="hidden lg:block">
          <NuxtLink v-scroll-to="'#why-were-different'" to="/experts-choice-awards#why-were-different" class="mt-4 block hover:text-blue">
            Why we’re different
          </NuxtLink>
          <NuxtLink v-scroll-to="'#winners'" to="/experts-choice-awards#winners" class="mt-4 block hover:text-blue">
            2024 winners
          </NuxtLink>
          <NuxtLink v-scroll-to="'#faq'" to="/experts-choice-awards#faq" class="mt-4 block hover:text-blue">
            FAQ
          </NuxtLink>
        </div>
      </div>

      <div class="mr-8 lg:mb-10">
        <NuxtLink to="/api" class="font-bw-gradual inline-block font-bold text-black" :class="{ 'nuxt-link-exact-active': $route.name === 'api' }">
          API
        </NuxtLink>

        <div v-if="$route.name === 'api'" class="hidden lg:block">
          <NuxtLink v-scroll-to="'#expert-review-api'" to="/api#expert-review-api" class="mt-4 block hover:text-blue">
            Expert Review API
          </NuxtLink>
          <NuxtLink v-scroll-to="'#benefits'" to="/api#benefits" class="mt-4 block hover:text-blue">
            Benefits
          </NuxtLink>
          <NuxtLink v-scroll-to="'#data-available'" to="/api#data-available" class="mt-4 block hover:text-blue">
            Data available
          </NuxtLink>
          <NuxtLink v-scroll-to="'#partner-studies'" to="/api#partner-studies" class="mt-4 block hover:text-blue">
            Partner studies
          </NuxtLink>
          <NuxtLink v-scroll-to="'#access'" to="/api#access" class="mt-4 block hover:text-blue">
            Access
          </NuxtLink>
        </div>
      </div>

      <div class="mr-8 lg:mb-10">
        <NuxtLink to="/business-support" class="font-bw-gradual inline-block font-bold text-black" :class="{ 'nuxt-link-exact-active': $route.name === 'business-support' }">
          Business support
        </NuxtLink>

        <div v-if="$route.name === 'business-support'" class="hidden lg:block">
          <NuxtLink v-scroll-to="'#listing-updates'" to="/business-support#listing-updates" class="mt-4 block hover:text-blue">
            Listing updates
          </NuxtLink>
          <NuxtLink v-scroll-to="'#winner-badge'" to="/business-support#winner-badge" class="mt-4 block hover:text-blue">
            Winners' badges
          </NuxtLink>
        </div>
      </div>

      <div class="mr-8 lg:mb-10">
        <NuxtLink to="/careers" class="font-bw-gradual inline-block font-bold text-black" :class="{ 'nuxt-link-exact-active': $route.name === 'career' }">
          Careers
        </NuxtLink>

        <div v-if="$route.name === 'career'" class="hidden lg:block">
          <NuxtLink v-scroll-to="'current-openning'" to="/career#current-openning" class="mt-4 inline-block hover:text-blue">
            Current openings
          </NuxtLink>
        </div>
      </div>

      <div class="mr-8">
        <NuxtLink to="/contact" class="font-bw-gradual inline-block font-bold text-black">
          Contact
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  //
}
</script>

<style lang="scss" scoped>
.nuxt-link-exact-active {
  @apply border-b-2 border-black;
}
.nuxt-link-active + div .nuxt-link-exact-active {
  @apply border-none text-blue;
}
</style>
